export default __webpack_public_path__ + "823ba626b73121aa2b3ef5ed7fe31c3c.svg";